<app-header [transparent]="transparent" />
<div class="career_at">
  <div class="text-center inline_padding2 bg_1 bg_img career_at_top">
    <div
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div
        id="formSuccessToast"
        class="toast align-items-center text-bg-success border-0"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">Form submitted successfully!</div>
          <button
            type="button"
            class="btn-close me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>

    <ng-container *ngFor="let heading of head">
      <div class="" *ngIf="heading.page === currentPage">
        <div class="inline_padding3">
          <span class="text_style_5">Career At</span>
        </div>
        <div class="inline_padding3 p-top-16">
          <span
            class="text_style_1"
            [innerHTML]="heading.page_sub_heading"
          ></span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="career_at_work p-b-90">
    <div class="text-center text_black_7">Why work with us?</div>
    <div class="career_at_work_box">
      <div class="career_at_work_box_item">
        <div class="career_at_work_box_item_left">
          <img src="../../../assets/icons/hands.png" />
        </div>
        <div class="p-x-20">
          <div class="text_black_14">Team Work</div>
          <div class="p-top-8">
            <span class="text_align-justify"
              >Best thing is you will get a chance to be a part of such a
              foremost & record-breaking team and learn more.</span
            >
          </div>
        </div>
      </div>
      <div class="career_at_work_box_item">
        <div class="career_at_work_box_item_left">
          <img src="../../../assets/icons/hands.png" />
        </div>
        <div class="p-x-20">
          <div class="text_black_14">Skill Development</div>
          <div class="p-top-8">
            <span class="text_align-justify"
              >You will get chances to use your ideas also you will free to
              sharpen your skills.</span
            >
          </div>
        </div>
      </div>
      <div class="career_at_work_box_item">
        <div class="career_at_work_box_item_left">
          <img src="../../../assets/icons/hands.png" />
        </div>
        <div class="p-x-20">
          <div class="text_black_14">Awesome Clients</div>
          <div class="p-top-8">
            <span class="text_align-justify"
              >You will get an opportunity to work for domestic as well as
              international clients we have from worldwide.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg_2">
    <div class="career_at_jobs">
      <div class="text-center text_blue_10">Current Jobs</div>
      <div class="career_at_jobs_body" *ngIf="jobs.length">
        <ng-container *ngFor="let job of jobs">
          <!-- <div class="career_at_jobs_body_container_box p-20">
                        <div class="career_at_jobs_body_container_box_card p-20 bg_1 border-radius-20 ">
                            <div class="text_blue_11">{{ job.title }}</div>
                            <ul style="list-style-type: disc;">
                                <li *ngFor="let responsibility of job.responsibilities" class="text_style_1 text-wrap">
                                    {{
                                    responsibility
                                    }}</li>
                            </ul>
                            <div class="text_style_4">Experience</div>
                            <ul style="list-style-type: disc;">
                                <li *ngFor="let exp of job.experience" class="text_style_1">{{ exp }}</li>
                            </ul>
                            <div class="career_at_jobs_body_box_btn">
                                <button class="text_white_1 button_blue_4 m-10">Apply</button>
                                <button class="text_blue_12 button_white_3">View Detail</button>
                            </div>
                        </div>
                    </div> -->
          <div class="career_at_jobs_body_container_box p-20">
            <div
              class="career_at_jobs_body_container_box_card p-20 bg_1 border-radius-20"
            >
              <div class="m-10">
                <div class="text_blue_11" [innerHtml]="job.title"></div>
                <div
                  [innerHtml]="job.description"
                  class="text-wrap text_lines_8"
                  style="text-align: justify"
                ></div>
              </div>
              <div *ngIf="job.web_link" class="p-top-12">
                <a
                  class="rounded-pill text_white_1 button_blue_7 text_decoration_none d-inline-flex align-items-center justify-content-center"
                  [href]="job.web_link.startsWith('http') ? job.web_link : 'https://' + job.web_link"
                  target="_blank"
                  style="min-height: 48px; min-width: 140px; padding: 10px 24px;"
                >
                  <span class="button_blue_1_text">Weblink</span>
                  <img
                    class="button_blue_1_text_icon ms-2"
                    src="../../../assets/icons/arrow-right.png"
                  />
                </a>
              </div>
              <div class="career_at_jobs_body_container_box_card_btn">
                <!-- Adjusted class -->
                <div
                  data-bs-toggle="modal"
                  data-bs-target="#apply"
                  (click)="openApplyModal(job.title)"
                >
                  <button
                    class="text_white_1 button_blue_4 career_at_jobs_body_container_box_card_btn_btn1"
                  >
                    Apply
                  </button>
                </div>
                <div data-bs-toggle="modal" data-bs-target="#detailbox">
                  <button
                    class="text_blue_12 button_white_3"
                    (click)="openModal(job)"
                  >
                    View Detail
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="career_at_bottom bg_1 text-center">
    <div class="inline_padding3">
      <span class="text_style_5">Would you like to join us?</span>
    </div>
    <div class="p-top-20 text_style_1">
      <span class="text_style_1">
        We are looking forward to enthusiastic and passionate people who want to
        work with us and create a history of Chem Robotics with us. Apply here.
      </span>
    </div>
    <div class="career_at_bottom_form">
      <form [formGroup]="careerForm" (ngSubmit)="submit_career_form()">
        <div class="dis-grid-2 text_align career_at_bottom_form_data">
          <div class="p-15">
            <label for="name" class="text_grey_2 p-bot-8">Name</label>
            <input
              type="text"
              name="name"
              formControlName="name"
              class="text_grey_1 height-50 border-radius-4 width-100-per p-x-15"
              placeholder="James"
            />
            <div *ngIf="formSubmitted && careerForm.controls['name'].invalid">
              <small class="text-red-1">Name is required.</small>
            </div>
          </div>

          <div class="p-15">
            <label for="email" class="text_grey_2 p-bot-8">Email</label>
            <input
              type="email"
              name="email"
              formControlName="email"
              class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
              placeholder="abc@gmail.com"
            />
            <div *ngIf="formSubmitted && careerForm.controls['email'].invalid">
              <small
                *ngIf="careerForm.controls['email'].errors?.['required']"
                class="text-red-1"
                >Email is required.</small
              >
              <small
                *ngIf="careerForm.controls['email'].errors?.['email']"
                class="text-red-1"
                >Invalid email format.</small
              >
            </div>
          </div>

          <div class="p-15">
            <label for="phone" class="text_grey_2 p-bot-8">Phone</label>
            <div class="width-100-per">
              <select
                id="countryCode"
                formControlName="country_code"
                class="text_grey_1 height-50 border-radius-4 p-x-10 width-25-per"
              >
                <option
                  *ngFor="let country of countries"
                  [value]="country.code"
                >
                  {{ country.code }}
                  <!-- Only display the code, since img tag cannot be used within an <option> -->
                </option>
              </select>

              <input
                type="tel"
                name="phone"
                formControlName="number"
                class="text_grey_1 height-50 border-radius-4 width-70-per p-x-15"
                placeholder="626 611 7944"
              />
            </div>
            <div *ngIf="formSubmitted && careerForm.controls['number'].invalid">
              <small
                *ngIf="careerForm.controls['number'].errors?.['required']"
                class="text-red-1"
                >Phone is required.</small
              >
              <small
                *ngIf="careerForm.controls['number'].errors?.['pattern']"
                class="text-red-1"
                >Phone number must be 10 digits.</small
              >
            </div>
          </div>

          <div class="p-15">
            <label for="city" class="text_grey_2 p-bot-8">City</label>
            <input
              type="text"
              name="city"
              formControlName="city"
              class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
              placeholder="Chicago"
            />
            <div *ngIf="formSubmitted && careerForm.controls['city'].invalid">
              <small class="text-red-1">City is required.</small>
            </div>
          </div>
        </div>
        <div class="text_align p-15 p-top-32">
          <label for="subject" class="text_grey_2 p-bot-8">Subject</label>
          <input
            type="text"
            id="subject"
            formControlName="subject"
            class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
            placeholder="Write Subject..."
            required
          />
          <div *ngIf="formSubmitted && careerForm.controls['subject'].invalid">
            <small class="text-red-1">Subject is required.</small>
          </div>
        </div>
        <div class="text_align p-10">
          <label for="message" class="text_grey_2 p-bot-8">Message</label>
          <textarea
            name="message"
            formControlName="message"
            class="text_grey_1 border-radius-4 width-100-per p-x-15"
            placeholder="Write message..."
            rows="4"
          ></textarea>
          <div *ngIf="formSubmitted && careerForm.controls['message'].invalid">
            <small class="text-red-1">Message is required.</small>
          </div>
        </div>
        <div class="p-top-32">
          <div
            class="dis-flex-2 border-radius-5-dotted bg_7 p-10"
            id="dropZone"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event)"
          >
            <input
              type="file"
              class="form-control-file select-document"
              #cvSelect
              id="FormControlPhotos"
              (change)="documentSelect($event)"
              style="display: none"
            />

            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.05414 10.4302H11.0902V19.4367C11.0902 20.3504 11.8311 21.0904 12.7439 21.0904H17.2579C18.1707 21.0904 18.9116 20.3505 18.9116 19.4367V10.4302H21.9466C22.4494 10.4302 22.9014 10.1275 23.0948 9.66284C23.2861 9.20009 23.1796 8.66513 22.8244 8.30988L15.8785 1.36311C15.3933 0.878964 14.6074 0.878964 14.1213 1.36311L7.17652 8.30988C6.8212 8.66513 6.71475 9.19918 6.90711 9.66284C7.10033 10.1266 7.55133 10.4302 8.05414 10.4302Z"
                fill="#0032A0"
              />
              <path
                d="M28.5083 13.8057C27.6853 13.8057 27.0176 14.4734 27.0176 15.2973V21.5344C27.0176 23.4028 25.4966 24.9227 23.6282 24.9227H6.3717C4.50322 24.9227 2.98327 23.4028 2.98327 21.5344V15.2973C2.98327 14.4734 2.31459 13.8057 1.49164 13.8057C0.667705 13.8057 0 14.4734 0 15.2974V21.5344C0 25.0477 2.85829 27.9061 6.3717 27.9061H23.6282C27.1416 27.9061 30 25.0478 30 21.5344V15.2974C30 14.4734 29.3322 13.8057 28.5083 13.8057Z"
                fill="#0032A0"
              />
            </svg>

            <span class="text_style_1">
              Drop file here or
              <a class="text_blue_9 p-x-20 height-50" (click)="cvSelect.click()"
                >Browse File</a
              >
            </span>
          </div>
          <div *ngIf="formSubmitted && !document">
            <small class="text-red-1">Please upload your CV.</small>
          </div>
        </div>
        <p class="text-start m-2">{{ document?.name }}</p>
        <!-- <div class="m-t-20 p-top-32">
          <re-captcha class="m-t-20" [siteKey]="recaptchaSiteKey" (resolved)="onCaptchaSuccess($event)">
          </re-captcha>
          <div *ngIf="formSubmitted && !recaptchaResponse">
            <small class="text-red-1">Please complete the reCAPTCHA.</small>
          </div>
        </div> -->
        <div class="m-t-20 p-top-32">
          <re-captcha
            class="m-t-20"
            [siteKey]="recaptchaSiteKey"
            (resolved)="onCaptchaSuccess($event)"
          >
          </re-captcha>
          <div *ngIf="formSubmitted && !recaptchaResponse">
            <small class="text-red-1">Please complete the reCAPTCHA.</small>
          </div>
        </div>
        <div *ngIf="errorMessage" class="text-red-1 m-t-10">
          {{ errorMessage }}
        </div>
        <div class="dis-flex-2 p-top-40">
          <button
            type="submit"
            class="rounded-pill text_white_1 button_blue_1 m-t-20 dis-block-1 button_blue_1_text"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<app-footer />

<div
  class="modal fade bg_4"
  id="detailbox"
  tabindex="-1"
  aria-labelledby="detailModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" *ngIf="jobs.length">
    <div class="modal-content bg_1">
      <div class="modal-header">
        <h5
          class="modal-title text_blue_11 p-y-24 p-x-40"
          id="detailModalLabel"
        >
          {{ selectedJob?.title }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body p-x-40 p-top-24">
        <div [innerHtml]="selectedJob?.description"></div>
        <div class="p-top-8 text-wrap" *ngIf="selectedJob?.web_link">
          <div>
            <span class="text_black_10">Weblink: </span>
          </div>
          <a
            [href]="selectedJob?.web_link.startsWith('http') ? selectedJob?.web_link : 'https://' + selectedJob?.web_link"
            class="text_blue_14"
            target="_blank"
          >
            {{ selectedJob?.web_link }}
          </a>
        </div>
      </div>
      <div class="career_at_jobs_body_box_btn dis-flex-5 p-x-40">
        <div class="p-bot-16">
          <button
            class="text_white_1 button_blue_4 m-10"
            data-bs-toggle="modal"
            data-bs-target="#apply"
            data-bs-dismiss="modal"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Structure -->
<div
  class="modal fade bg_4"
  id="apply"
  aria-labelledby="apply_form"
  aria-hidden="true"
>
  <div class="modal-dialog text-center modal-dialog-centered modal-lg">
    <div class="modal-content p-x-15 bg_1">
      <div class="modal-header">
        <h5 class="modal-title" id="apply_form">Apply</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="careerForm" (ngSubmit)="submit_career_form()">
          <div class="dis-grid-2 text_align career_at_bottom_form_data">
            <div class="p-15">
              <label for="name" class="text_grey_2 p-bot-8">Name</label>
              <input
                type="text"
                name="name"
                formControlName="name"
                class="text_grey_1 height-50 border-radius-4 width-100-per p-x-15"
                placeholder="James"
              />
              <div *ngIf="formSubmitted && careerForm.controls['name'].invalid">
                <small class="text-red-1">Name is required.</small>
              </div>
            </div>

            <div class="p-15">
              <label for="email" class="text_grey_2 p-bot-8">Email</label>
              <input
                type="email"
                name="email"
                formControlName="email"
                class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
                placeholder="abc@gmail.com"
              />
              <div
                *ngIf="formSubmitted && careerForm.controls['email'].invalid"
              >
                <small
                  *ngIf="careerForm.controls['email'].errors?.['required']"
                  class="text-red-1"
                  >Email is required.</small
                >
                <small
                  *ngIf="careerForm.controls['email'].errors?.['email']"
                  class="text-red-1"
                  >Invalid email format.</small
                >
              </div>
            </div>

            <div class="p-15">
              <label for="phone" class="text_grey_2 p-bot-8">Phone</label>
              <div class="width-100-per">
                <select
                  id="countryCode"
                  formControlName="country_code"
                  class="text_grey_1 height-50 border-radius-4 p-x-10 width-25-per"
                >
                  <option
                    *ngFor="let country of countries"
                    [value]="country.code"
                  >
                    {{ country.code }}
                    <!-- Only display the code, since img tag cannot be used within an <option> -->
                  </option>
                </select>
                <input
                  type="tel"
                  name="phone"
                  formControlName="number"
                  class="text_grey_1 height-50 border-radius-4 width-70-per p-x-15"
                  placeholder="626 611 7944"
                />
              </div>
              <div
                *ngIf="formSubmitted && careerForm.controls['number'].invalid"
              >
                <small
                  *ngIf="careerForm.controls['number'].errors?.['required']"
                  class="text-red-1"
                  >Phone is required.</small
                >
                <small
                  *ngIf="careerForm.controls['number'].errors?.['pattern']"
                  class="text-red-1"
                  >Phone number must be 10 digits.</small
                >
              </div>
            </div>

            <div class="p-15">
              <label for="city" class="text_grey_2 p-bot-8">City</label>
              <input
                type="text"
                name="city"
                formControlName="city"
                class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
                placeholder="Chicago"
              />
              <div *ngIf="formSubmitted && careerForm.controls['city'].invalid">
                <small class="text-red-1">City is required.</small>
              </div>
            </div>
          </div>
          <div class="text_align p-15 p-top-32">
            <label for="subject" class="text_grey_2 p-bot-8">Subject</label>
            <input
              type="text"
              id="subject"
              formControlName="subject"
              class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
              placeholder="Write Subject..."
              required
            />
          </div>
          <div class="text_align p-10">
            <label for="message" class="text_grey_2 p-bot-8">Message</label>
            <textarea
              name="message"
              formControlName="message"
              class="text_grey_1 border-radius-4 width-100-per p-x-15"
              placeholder="Write message..."
              rows="4"
            ></textarea>
            <div
              *ngIf="formSubmitted && careerForm.controls['message'].invalid"
            >
              <small class="text-red-1">Message is required.</small>
            </div>
          </div>
          <div class="p-top-32">
            <div
              class="dis-flex-2 border-radius-5-dotted bg_7 p-10"
              (dragover)="onDragOver($event)"
              (drop)="onDrop($event)"
            >
              <input
                type="file"
                class="form-control-file select-document"
                #cvSelect
                id="FormControlPhotos"
                (change)="documentSelect($event)"
                style="display: none"
              />

              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.05414 10.4302H11.0902V19.4367C11.0902 20.3504 11.8311 21.0904 12.7439 21.0904H17.2579C18.1707 21.0904 18.9116 20.3505 18.9116 19.4367V10.4302H21.9466C22.4494 10.4302 22.9014 10.1275 23.0948 9.66284C23.2861 9.20009 23.1796 8.66513 22.8244 8.30988L15.8785 1.36311C15.3933 0.878964 14.6074 0.878964 14.1213 1.36311L7.17652 8.30988C6.8212 8.66513 6.71475 9.19918 6.90711 9.66284C7.10033 10.1266 7.55133 10.4302 8.05414 10.4302Z"
                  fill="#0032A0"
                />
                <path
                  d="M28.5083 13.8057C27.6853 13.8057 27.0176 14.4734 27.0176 15.2973V21.5344C27.0176 23.4028 25.4966 24.9227 23.6282 24.9227H6.3717C4.50322 24.9227 2.98327 23.4028 2.98327 21.5344V15.2973C2.98327 14.4734 2.31459 13.8057 1.49164 13.8057C0.667705 13.8057 0 14.4734 0 15.2974V21.5344C0 25.0477 2.85829 27.9061 6.3717 27.9061H23.6282C27.1416 27.9061 30 25.0478 30 21.5344V15.2974C30 14.4734 29.3322 13.8057 28.5083 13.8057Z"
                  fill="#0032A0"
                />
              </svg>

              <span class="text_style_1" (drop)="onDrop($event)">
                Drop file here or
                <a
                  class="text_blue_9 p-x-20 height-50"
                  (click)="cvSelect.click()"
                  >Browse File</a
                >
              </span>
            </div>
            <div *ngIf="formSubmitted && !document">
              <small class="text-red-1">Please upload your CV.</small>
            </div>
          </div>
          <p class="text-start m-2">{{ document?.name }}</p>
          <!-- <div class=" m-t-20 p-top-32" >
          <re-captcha 
          class="m-t-20"  
          [siteKey]="recaptchaSiteKey" 
          formControlName="recaptcha">
          </re-captcha>
          </div> -->
          <div class="m-t-20 p-top-32">
            <re-captcha
              class="m-t-20"
              [siteKey]="recaptchaSiteKey"
              (resolved)="onCaptchaSuccess($event)"
            >
            </re-captcha>
            <div *ngIf="formSubmitted && !recaptchaResponse">
              <small class="text-red-1">Please complete the reCAPTCHA.</small>
            </div>
          </div>
          <div *ngIf="errorMessage" class="text-red-1 m-t-10">
            {{ errorMessage }}
          </div>
          <div class="dis-flex-2 p-top-40">
            <button
              type="submit"
              class="rounded-pill text_white_1 button_blue_1 m-t-20 dis-block-1 button_blue_1_text"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
